const REQUEST_PERMISSIONS_SUCCESS = 'REQUEST_PERMISSIONS_SUCCESS';
const REQUEST_PERMISSIONS_FAILURE = 'REQUEST_PERMISSIONS_FAILURE';
export { REQUEST_PERMISSIONS_SUCCESS, REQUEST_PERMISSIONS_FAILURE };
